import { gql } from "@apollo/client";

//To upload image in library 
export const UPLOAD_LIBRARY_IMAGE=gql`
mutation UploadMultipleMylibraryImagesAndPodcasts(
  $libraryId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $files: JSON!
) {
  uploadMultipleMylibraryImagesAndPodcasts(
    input: {
      pLId: $libraryId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pFiles: $files
    }
  ) {
    json
  }
}
`;

export const EDIT_IMAGE_OR_PODCAST  = gql`
mutation EditMylibraryImageOrPodcast(
  $fileId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $fileType: String!
  $newFilename: String
  $newFilepath: String
  $newFilesize: BigInt
  $newCoverImage: String
  $newFileDescription: String
) {
  editMylibraryImageOrPodcast(
    input: {
      pFileId: $fileId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pType: $fileType
      pNewFilename: $newFilename
      pNewFilepath: $newFilepath
      pNewFilesize: $newFilesize
      pNewCoverImage: $newCoverImage
      pNewFileDescription: $newFileDescription
    }
  ) {
    json
  }
}
`

export const EDIT_MYLIBRARY_MATERIALS = gql`
mutation EditMylibraryEbookMaterial(
  $fileId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $typeName: String!
  $newFilename: String
  $newFilepath: String
  $newFilesize: BigInt
  $newCoverImage: String
  $newAuthorName: String
  $newFiletype: String
) {
  editMylibraryEbookMaterial(
    input: {
      pFileId: $fileId
      pClassroomId: $classroomId
      pSubjectId: $subjectId
      pTypeName: $typeName
      pNewFilename: $newFilename
      pNewFilepath: $newFilepath
      pNewFilesize: $newFilesize
      pNewCoverImage: $newCoverImage
      pNewAuthorName: $newAuthorName
      pNewFiletype: $newFiletype
    }
  ) {
    json
  }
}
`

export const EDIT_QUESTION_BANK_MATERIALS = gql`
mutation EditQuestionBanks(
  $fileId: UUID!
  $classroomId: UUID!
  $subjectId: UUID!
  $newFilename: String
  $newFilepath: String
  $newFilesize: BigInt
) {
  editQuestionBanks(
    input: {
      fileId: $fileId
      classroomId: $classroomId
      subjectId: $subjectId
      newFilename: $newFilename
      newFilepath: $newFilepath
      newFilesize: $newFilesize
    }
  )
}
`

//To view all images in library
export const VIEW_ALL_LIBRARY_IMAGES=gql`
query getmyLibraryImagesPodcastsInfo(
  $lId: UUID!
  $sjId: UUID!
  $cId: UUID!
  $limit: Int = null
  $offset: Int = null
  $searchInput: String = "%"
  $isClassroom: [Boolean!] = [true, false]
) {
  getMylibraryImagesPodcastsInfo(
    pClassroomId: $cId
    pSubjectId: $sjId
    pLId: $lId
    first: $limit
    offset: $offset
    filter: {
      filename: { likeInsensitive: $searchInput }
      or: [
        {
          and: [
            { sharedBy: { isNull: true } }
            { isClassroom: { in: $isClassroom } }
          ]
        }
        {
          and: [
            { sharedBy: { isNull: false } }
            { isClassroom: { equalTo: true } }
          ]
        }
      ]
    }
  ) {
    nodes {
      filename
      filepath
      isclassroom: isClassroom
      filesize
      fileDescription
      coverImagePath
      fileId
      feedId
      sharedBy
    }
    totalCount
  }
}
  `;

export const UPDATE_IMAGES_PODCASTS = gql`
mutation updateImagesPodcasts($cId: UUID!, $fId: UUID!, $isClassroom: Boolean!, $lId: UUID!, $sjId: UUID!) {
  updateImagesPodcastMaterials(
    input: {pClassroomId: $cId, pFileId: $fId, pIsClassroom: $isClassroom, pLibraryId: $lId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;

export const DELETE_IMAGES_PODCASTS = gql`
mutation deleteImagesPodcasts($cId: UUID!, $fId: UUID!, $lId: UUID!, $sjId: UUID!) {
  deleteImagesAndPodcasts(
    input: {pClassroomId: $cId, pFileId: $fId, pLibraryId: $lId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}`;


export const VIEW_ALL_LIBRARY_IMAGES_ADMIN = gql`
query GetMylibraryImagesForAdmin(
  $subjectId: UUID!
  $searchInput: String
  $classroomIds: [UUID!]
  $limit: Int
  $offset: Int
) {
  getMylibraryImagesForAdmin(
    pSubjectId: $subjectId
    filter: { filename: { likeInsensitive: $searchInput } }
    pClassroomIds: $classroomIds
    first: $limit
    offset: $offset
  ) {
    nodes {
      fileId
      filename
      filepath
      filesize
      isclassroom: isClassroom
      coverImagePath
      fileDescription
      subjectId
    }
    totalCount
  }
}
`;

export const UPLOAD_LIBRARY_IMAGE_ADMIN = gql`
mutation UploadMylibraryImagesBySchoolAdmin(
  $files: JSON!
  $classroomIds: [UUID!]!
  $subjectId: UUID!
) {
  uploadMylibraryImagesBySchoolAdmin(
    input: {
      pFiles: $files
      pClassroomIds: $classroomIds
      pSubjectId: $subjectId
    }
  ) {
    result: json
  }
}
`;

export const UPDATE_IMAGES_PODCASTS_ADMIN = gql`
  mutation UpdateImagesPodcastMaterialsBySchoolAdmin(
    $input: UpdateImagesPodcastMaterialsBySchoolAdminInput!
  ) {
    updateImagesPodcastMaterialsBySchoolAdmin(input: $input) {
      string
    }
  }
`;

export const DELETE_IMAGES_PODCASTS_ADMIN = gql `
mutation DeleteImagesPodcastsBySchoolAdmin(
  $input: DeleteImagesPodcastsBySchoolAdminInput!
) {
  deleteImagesPodcastsBySchoolAdmin(input: $input) {
    string
  }
}
`
